import dynamic from "next/dynamic";
import { useRouter } from "next/router";
import PropTypes from "prop-types";
import { getPageShellDataSafely } from "@/services/contenful/getPageShellDataSafe";
import BrandRegistration from "@/components/CustomComponents/BrandRegistration";
import BRAND_REGISTRATION_CONSTANTS from "@/components/CustomComponents/BrandRegistration/brandRegistrationConstants";
import ContactUsForm from "@/components/CustomComponents/ContactUsForm";
import { contactFormConfig } from "@/components/CustomComponents/ContactUsForm/constants";
import BackToTop from "@/components/backToTop";

const Loader = dynamic(() => import("@/components/loader"));
const Landing = dynamic(() => import("@/components/landing"));

const LandingPage = ({
  pageData = {},
  slugPath = "",
  apacConfigurationsData = {},
}) => {
  const router = useRouter();
  const contactFormConfiglabels = contactFormConfig.en;

  if (router.isFallback) {
    return <Loader loading={router.isFallback} />;
  }
  if (pageData?.slug === "/about-us") {
    return (
      <>
        <Landing pageData={pageData} />
        <BackToTop topHeight={0} />
      </>
    );
  }
  switch (slugPath) {
    case "brand-registration":
      return (
        <BrandRegistration
          brandRegistrationData={BRAND_REGISTRATION_CONSTANTS}
        />
      );
    case "contact-form":
      return (
        <ContactUsForm
          formConfig={contactFormConfiglabels}
          contactFormConfigurationsData={apacConfigurationsData}
        />
      );
    default:
      return <Landing pageData={pageData} />;
  }
};

export async function getServerSideProps({ params, preview }) {
  // const { slug = "/" } = params;
  const slugArray = params?.slug || [];
  const slugPath = slugArray.join("/");
  const {
    items,
    headerNavigationData,
    footerNavigationData,
    promoBannerData,
    worldwideMenuData,
    apacConfigurationsData,
  } = await getPageShellDataSafely({
    slug: slugPath ? `/${slugPath}` : "/",
    preview,
    contentType: "brazilLandingPage",
    fetchEntryBySlugFlag: true,
  });
  const pageProps = {
    props: {
      headerNavigationData,
      footerNavigationData,
      promoBannerData,
      world: worldwideMenuData,
      apacConfigurationsData,
    },
  };
  if (slugPath === "brand-registration" || slugPath === "contact-form") {
    pageProps.props.slugPath = slugPath;
    return pageProps;
  }

  const pageData = items?.[0]?.fields;
  if (!pageData) {
    return {
      notFound: true,
    };
  }
  pageProps.props.pageData = pageData;
  return pageProps;
}

LandingPage.propTypes = {
  pageData: PropTypes.object,
  slugPath: PropTypes.string,
  apacConfigurationsData: PropTypes.object,
};

export default LandingPage;
